import { Injectable } from '@angular/core';

import { RestService } from "../../../../core/services/rest.service";
import { TipoOrgao } from "./orgao-tipo.model";
import { apiName } from "./data.service";

@Injectable()
export class OrgaoTipoApiService {

  constructor(
    private _restService: RestService,
  ) { }

  onPost(object: TipoOrgao, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoOrgao, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"include":["estado"],"order":["codigoTCE"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["estado"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/shared/orgao-tipo-api.service.ts
 **/